/**
 * Lista global de tags só para Estabelecimentos (independente de `naviex-admin-tags` / Experiências).
 */

import { getEstabelecimentos, normalizeEstabelecimentoForStore, saveEstabelecimento } from './estabelecimentosStorage';

const KEY_ESTABELECIMENTOS_TAGS = 'naviex-admin-estabelecimentos-tags';

function loadJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

function saveJson(key: string, value: unknown): void {
  localStorage.setItem(key, JSON.stringify(value));
}

/** Tags sugeridas no picker (lista pode crescer com «Adicionar» ou por uso nos cadastros). */
export function getEstabelecimentoTags(): string[] {
  try {
    const data = loadJson<string[]>(KEY_ESTABELECIMENTOS_TAGS, []);
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}

function saveEstabelecimentoTags(list: string[]): void {
  saveJson(KEY_ESTABELECIMENTOS_TAGS, list);
}

/** Inclui na lista global se ainda não existir (trim; comparação exata). */
export function addEstabelecimentoTag(name: string): void {
  const t = name.trim();
  if (!t) return;
  const list = getEstabelecimentoTags();
  if (list.includes(t)) return;
  list.push(t);
  list.sort((a, b) => a.localeCompare(b, 'pt-BR'));
  saveEstabelecimentoTags(list);
}

/** Renomeia na lista global e em todos os estabelecimentos que usam a tag. */
export function renameEstabelecimentoTag(oldName: string, newName: string): void {
  const t = newName.trim();
  if (!t || t === oldName) return;
  const list = getEstabelecimentoTags().filter((x) => x !== oldName);
  if (!list.includes(t)) list.push(t);
  list.sort((a, b) => a.localeCompare(b, 'pt-BR'));
  saveEstabelecimentoTags(list);
  getEstabelecimentos().forEach((est) => {
    if ((est.tags ?? []).includes(oldName)) {
      saveEstabelecimento(
        normalizeEstabelecimentoForStore({
          ...est,
          tags: (est.tags ?? []).map((tag) => (tag === oldName ? t : tag)),
        })
      );
    }
  });
}

/** Remove da lista global e de todos os estabelecimentos. */
export function removeEstabelecimentoTagCompletely(name: string): void {
  saveEstabelecimentoTags(getEstabelecimentoTags().filter((x) => x !== name));
  getEstabelecimentos().forEach((est) => {
    if ((est.tags ?? []).includes(name)) {
      saveEstabelecimento(
        normalizeEstabelecimentoForStore({
          ...est,
          tags: (est.tags ?? []).filter((x) => x !== name),
        })
      );
    }
  });
}
